export const BANDS_SELECTED_CHAT_STORAGE_KEY = "muzone.bands.selectedChat";
export const BANDS_DIRECT_INTENT_STORAGE_KEY = "muzone.bands.directIntent";
export const BANDS_SELECTED_BAND_OBJECT_STORAGE_KEY = "muzone.bands.selectedBandObject";

export const BANDS_VIEW_MODE_STORAGE_KEY = "muzone.bands.viewMode.v1";
export const BANDS_VIEW_MODE_WELCOME = "welcome";
export const BANDS_VIEW_MODE_WORKSPACE = "workspace";
export const BANDS_VIEW_MODES = Object.freeze([
    BANDS_VIEW_MODE_WELCOME,
    BANDS_VIEW_MODE_WORKSPACE,
]);
export const BANDS_DEFAULT_VIEW_MODE = BANDS_VIEW_MODE_WELCOME;
